<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
          }}</span>
        <span class="masge">当前共有{{ total }}条{{ this.route.menuName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Export') != -1" type="primary" class="btn primary" @click="exportData"
            v-loading="exportButtonLoading" :disabled="exportButtonLoading">导出</el-button>
          <!-- <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small" v-preventReClick @click="handleAdd1">新增</el-button>
          <el-button v-if="tableAcl.indexOf('Remove') != -1" class="btn" size="small" :disabled="multiple" v-preventReClick @click="handleDelete">删除</el-button> -->
          <el-dropdown v-if="tableAcl.indexOf('Print') != -1" @command="printList">
            <el-button v-if="tableAcl.indexOf('Print') != -1" class="btn primary" type="primary">
              打印
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="0">打印</el-dropdown-item>
              <el-dropdown-item command="1">预览</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange"
            @reset="reset"></SelectFilter>
        </div>
        <div class="right">
          <el-button class="btn primary" type="primary" style="margin-right: 10px"
          @click="showTransfer">自定义设置</el-button>
        </div>
      </div>
      <div v-if="tableHaeder.length>0">
        <CustomTable  ref="customTable" :tableData="tableData" @handleSelectionChange="handleSelectionChange" :tableHaeder="tableHaeder" :loading="loading"
        @resetMethod="reset" :tableHeight="tableHeight" @onApproveStatusSuccess="getData" :tableCode="route.name"> 
        
        </CustomTable>
    </div>
    <div v-else>
      <el-table ref="multipleTable" border v-loading="loading" :data="tableData" :max-height="tableHeight"
      style="width: 100%" stripe :header-cell-style="{ background: '#DDEBFF' }">
      <template slot="empty">
        <div class="empty-div" :style="{ height: tableHeight + 'px' }">
          <img src="../../../../assets/noData.png" width="240" height="240" />
          <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
          <div class="empty-rest" @click="reset">恢复默认</div>
        </div>
      </template>
      <el-table-column show-overflow-tooltip width="120" prop="firstCategoryName" label="一级分类名称"></el-table-column>
      <el-table-column show-overflow-tooltip width="120" prop="secondCategoryName" label="二级分类名称"
        v-if="query.viewMode != 1">
        <template slot-scope="scope">
          {{ scope.row.secondCategoryName?scope.row.secondCategoryName:'-' }}
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip width="170" prop="supplierProductNo" label="供应商产品编码"
        v-if="query.viewMode == 0"></el-table-column>
      <el-table-column show-overflow-tooltip width="140" prop="productName" label="产品名称"
        v-if="query.viewMode == 0"></el-table-column>
      <el-table-column show-overflow-tooltip width="140" prop="specName" label="规格型号"
        v-if="query.viewMode == 0"></el-table-column>
      <el-table-column show-overflow-tooltip width="120" prop="warehouseName" label="库房"></el-table-column>
      <el-table-column width="50" prop="unit" label="单位" v-if="query.viewMode == 0"></el-table-column>
      <el-table-column show-overflow-tooltip width="160" prop="manufacturerName" label="生产厂家"
        v-if="query.viewMode == 0"></el-table-column>
      <el-table-column prop="medicalInsuranceCategoryNo" show-overflow-tooltip label="医保代码"
        width="200">
        <template slot-scope="scope">
          {{ scope.row.medicalInsuranceCategoryNo?scope.row.medicalInsuranceCategoryNo:'-' }}
        </template>
      </el-table-column>

      <el-table-column width="120" prop="startDate" label="开始日期">
        <template slot-scope="scope">{{
          parseTime(new Date(scope.row.startDate), "{y}-{m}-{d}")
          }}</template>
      </el-table-column>
      <el-table-column width="120" prop="endDate" label="结束日期">
        <template slot-scope="scope">{{
          parseTime(new Date(scope.row.endDate), "{y}-{m}-{d}")
          }}</template>
      </el-table-column>

      <el-table-column label="期初情况" align="center">
        <el-table-column width="120" prop="startStockNumber" label="期初库存数量"></el-table-column>
        <el-table-column width="120" prop="startStockAmount" label="期初库存金额"></el-table-column>
      </el-table-column>

      <el-table-column label="本期增加" align="center">
        <el-table-column width="70" prop="acceptInStockNumber" label="采购入库数量"></el-table-column>
        <el-table-column width="70" prop="acceptInStockAmount" label="采购入库金额"></el-table-column>
        <el-table-column width="70" prop="applyInStockNumber" label="请领退库数量"></el-table-column>
        <el-table-column width="70" prop="applyInStockAmount" label="请领退库金额"></el-table-column>
        <el-table-column width="70" prop="deptInStockNumber" label="科室入库数量"></el-table-column>
        <el-table-column width="70" prop="deptInStockAmount" label="科室入库金额"></el-table-column>
        <el-table-column width="70" prop="collectInStockNumber" label="领用退库数量"></el-table-column>
        <el-table-column width="70" prop="collectInStockAmount" label="领用退库金额"></el-table-column>
        <el-table-column width="70" prop="stockTransferInNumber" label="调拨入库数量"></el-table-column>
        <el-table-column width="70" prop="stockTransferInAmount" label="调拨入库金额"></el-table-column>
        <el-table-column width="70" prop="stockProfitLossInNumber" label="盘盈入库数量"></el-table-column>
        <el-table-column width="70" prop="stockProfitLossInAmount" label="盘盈入库金额"></el-table-column>
        <el-table-column width="70" prop="periodInStockNumber" label="期初入库数量"></el-table-column>
        <el-table-column width="70" prop="periodInStockAmount" label="期初入库金额"></el-table-column>
        <el-table-column width="70" prop="gainsLossInAmount" label="库存损益(正)"></el-table-column>
        <el-table-column width="120" prop="inStockNumber" label="本期入库数量"></el-table-column>
        <el-table-column width="120" prop="inStockAmount" label="本期入库金额"></el-table-column>
      </el-table-column>

      <el-table-column label="本期减少" align="center">
        <el-table-column width="70" prop="acceptOutStockNumber" label="采购退货数量"></el-table-column>
        <el-table-column width="70" prop="acceptOutStockAmount" label="采购退货金额"></el-table-column>
        <el-table-column width="70" prop="applyOutStockNumber" label="请领出库数量"></el-table-column>
        <el-table-column width="70" prop="applyOutStockAmount" label="请领出库金额"></el-table-column>
        <el-table-column width="70" prop="deptOutStockNumber" label="科室退库数量"></el-table-column>
        <el-table-column width="70" prop="deptOutStockAmount" label="科室退库金额"></el-table-column>
        <el-table-column width="70" prop="collectOutStockNumber" label="领用出库数量"></el-table-column>
        <el-table-column width="70" prop="collectOutStockAmount" label="领用出库金额"></el-table-column>
        <el-table-column width="70" prop="stockTransferOutNumber" label="调拨出库数量"></el-table-column>
        <el-table-column width="70" prop="stockTransferOutAmount" label="调拨出库金额"></el-table-column>
        <el-table-column width="70" prop="stockProfitLossOutNumber" label="盘亏出库数量"></el-table-column>
        <el-table-column width="70" prop="stockProfitLossOutAmount" label="盘亏出库金额"></el-table-column>
        <el-table-column width="70" prop="lossOutStoctNumber" label="报损出库数量"></el-table-column>
        <el-table-column width="70" prop="lossOutStoctAmount" label="报损出库金额"></el-table-column>
        <el-table-column width="70" prop="periodOutStockNumber" label="期初出库数量"></el-table-column>
        <el-table-column width="70" prop="periodOutStockAmount" label="期初出库金额"></el-table-column>
        <el-table-column width="70" prop="gainsLossOutAmount" label="库存损益(负)"></el-table-column>
        <el-table-column width="120" prop="outStockNumber" label="本期出库数量"></el-table-column>
        <el-table-column width="120" prop="outStockAmount" label="本期出库金额"></el-table-column>
      </el-table-column>

      <el-table-column label="期末结存" align="center">
        <el-table-column width="120" prop="endStockNumber" label="期末库存数量"></el-table-column>
        <el-table-column width="120" prop="endStockAmount" label="期末库存金额"></el-table-column>
        <!-- <el-table-column width="120" prop="gainsLossAmount" label="损益金额"></el-table-column> -->
      </el-table-column>

      <!-- <el-table-column fixed="right">
        <el-table-column prop="operation" label="操作" width="180">
          <template slot-scope="scope">
            <el-button type="text" v-preventReClick @click="handleInfo1(scope.row)" class="color-blue">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table-column> -->
    </el-table>
    </div>
  
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange"
        :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>

    <el-dialog :title="title + route.menuName" :visible.sync="open" :center="true" width="1100px" :before-close="cancel"
      :close-on-click-modal="false">
      <el-form label-position="top" label-width="80px" ref="form" :model="form">
        <el-row>
          <el-col :span="12">
            <el-form-item label="一级分类">
              <el-input disabled v-model="form.firstCategoryName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="query.viewMode != 1">
            <el-form-item label="二级分类">
              <el-input disabled v-model="form.secondCategoryName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="query.viewMode == 0">
          <el-col :span="6">
            <el-form-item label="供应商产品编码">
              <el-input disabled v-model="form.supplierProductNo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="产品名称">
              <el-input disabled v-model="form.productName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="规格型号">
              <el-input disabled v-model="form.specName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="生产厂家">
              <el-input disabled v-model="form.manufacturerName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="库房">
              <el-input disabled v-model="form.warehouseName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="开始时间">
              <el-date-picker style="width: 100%" disabled v-model="form.startDate" size="small" type="date"
                format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="结束时间">
              <el-date-picker style="width: 100%" disabled v-model="form.endDate" size="small" type="date"
                format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="数量">
              <el-input disabled v-model="form.startStockNumber"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="startStockAmount" label="期初库存金额">
              <el-input disabled v-model="form.startStockAmount"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="4">
            <el-form-item label="采购入库数量">
              <el-input disabled v-model="form.acceptInStockNumber"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="采购入库金额">
              <el-input disabled v-model="form.acceptInStockAmount"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="请领退库数量">
              <el-input disabled v-model="form.applyInStockNumber"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="请领退库金额">
              <el-input disabled v-model="form.applyInStockAmount"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="科室入库数量">
              <el-input disabled v-model="form.deptInStockNumber"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="科室入库金额">
              <el-input disabled v-model="form.deptInStockAmount"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <el-form-item label="领用退库数量">
              <el-input disabled v-model="form.collectInStockNumber"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="领用退库金额">
              <el-input disabled v-model="form.collectInStockAmount"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="调拨入库数量">
              <el-input disabled v-model="form.stockTransferInNumber"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="调拨入库金额">
              <el-input disabled v-model="form.stockTransferInAmount"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="盘盈入库数量">
              <el-input disabled v-model="form.stockProfitLossInNumber"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="盘盈入库金额">
              <el-input disabled v-model="form.stockProfitLossInAmount"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <el-form-item label="期初入库数量">
              <el-input disabled v-model="form.periodInStockNumber"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="期初入库金额">
              <el-input disabled v-model="form.periodInStockAmount"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="库存损益(正)">
              <el-input disabled v-model="form.gainsLossInAmount"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="8">
            <el-form-item prop="inStockNumber" label="本期入库数量">
              <el-input disabled v-model="form.inStockNumber"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="本期入库金额">
              <el-input disabled v-model="form.inStockAmount"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="4">
            <el-form-item label="采购退货数量">
              <el-input disabled v-model="form.acceptOutStockNumber"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="采购退货金额">
              <el-input disabled v-model="form.acceptOutStockAmount"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="请领出库数量">
              <el-input disabled v-model="form.applyOutStockNumber"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="请领出库金额">
              <el-input disabled v-model="form.applyOutStockAmount"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="科室退库数量">
              <el-input disabled v-model="form.deptOutStockNumber"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="科室退库金额">
              <el-input disabled v-model="form.deptOutStockAmount"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <el-form-item label="领用出库数量">
              <el-input disabled v-model="form.collectOutStockNumber"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="领用出库金额">
              <el-input disabled v-model="form.collectOutStockAmount"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="调拨出库数量">
              <el-input disabled v-model="form.stockTransferOutNumber"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="调拨出库金额">
              <el-input disabled v-model="form.stockTransferOutAmount"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="盘亏出库数量">
              <el-input disabled v-model="form.stockProfitLossOutNumber"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="盘亏出库金额">
              <el-input disabled v-model="form.stockProfitLossOutAmount"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <el-form-item label="期初出库数量">
              <el-input disabled v-model="form.periodOutStockNumber"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="期初出库金额">
              <el-input disabled v-model="form.periodOutStockAmount"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="报损出库数量">
              <el-input disabled v-model="form.lossOutStoctNumber"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="报损出库金额">
              <el-input disabled v-model="form.lossOutStoctAmount"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="库存损益(负)">
              <el-input disabled v-model="form.gainsLossOutAmount"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="8">
            <el-form-item label="本期出库数量">
              <el-input disabled v-model="form.outStockNumber"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="本期出库金额">
              <el-input disabled v-model="form.outStockAmount"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="期末库存数量">
              <el-input disabled v-model="form.endStockNumber"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="期末库存金额">
              <el-input disabled v-model="form.endStockAmount"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn" size="small" v-preventReClick @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
    <Transfer ref="Transfer" @getTabelList="getTabelList" :transfer-props="transferProps" />
  </div>
  
</template>

<script>
import {
  GetStockBalancePrintData,
  GetStockBalances,
  GetStockBalanceLog,
  ExportStockBalance,
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
// import { StockCategoryOptions } from "@/enum";
import SelectFilter from "@/components/table-select-filter";
import BaseListMixin from "@/mixin/baseList-mixin.js";

export default {
  mixins: [GetDataMixin, GetDataSpdMixin, BaseListMixin],
  components: {
    SelectFilter,
  },
  data() {
    return {
      GetDatasAction: GetStockBalances,
      exportAction: ExportStockBalance,
      // RemoveAction: RemoveStockBalance,
      // PrintAction: GetStockBalancePrintData,
      // editPath: 'apply-out-stock-edit',

      // StockCategoryOptions: StockCategoryOptions,
      filterOptions: [
        {
          name: "查看方式",
          type: "select",
          code: "viewMode",
          data: [
            {
              id: 0,
              name: "按明细查看",
            },
            {
              id: 1,
              name: "按一级分类汇总",
            },
            {
              id: 2,
              name: "按二级分类汇总",
            },
          ],
        },
        {
          name: "一级分类",
          type: "input",
          code: "firstCategoryName",
        },
        {
          name: "二级分类",
          type: "input",
          code: "secondCategoryName",
        },
        {
          name: "供应商产品编码",
          type: "input",
          code: "supplierProductNo",
        },
        {
          name: "产品名称",
          type: "input",
          code: "productName",
        },
        {
          name: "规格型号",
          type: "input",
          code: "specName",
        },
        {
          name: "生产厂家",
          type: "select",
          code: "manufacturerId",
          filterMethod: this.getManufacturers,
          data: [],
        },
        {
          name: "结存记录",
          type: "select",
          code: "logId",
          filterMethod: this.getStockBalanceLogList,
          data: [],
        },
        {
          name: "供货商产品",
          type: "select",
          code: "supplierProductId",
          filterMethod: this.getSupplierProductsNoDebounce,
          data: [],
        },
        // {
        //   name: "主条码",
        //   type: "input",
        //   code: "mainNo",
        // },
      ],
      // 弹出框标题
      title: "",
      // 弹出编辑框
      open: false,
      // 新增、编辑的数据
      form: {},
      editMode: false,
      stockBalanceLogList: [],
    };
  },
  methods: {
    // 编辑
    handleInfo1(row) {
      this.resetForm();
      this.form = JSON.parse(JSON.stringify(row));
      this.open = true;
      this.title = "查看";
      this.editMode = false;
    },
    resetForm() {
      this.form = {
        id: 0,
        warehouseId: "",
        startDate: "",
        endDate: "",
        orgCode :sessionStorage.getItem('orgId'),
      };
    },
    // 取消编辑
    cancel() {
      this.$store.dispatch('SetLoading', false)
      this.open = false;
    },

    printList(command) {
      this.query.type = command;

      GetStockBalancePrintData(this.query).then((res) => {
        var result = res.returnData;

        var printData = this.printDataConvert(result.printData);
        this.sendPrintMessage(JSON.stringify(printData));
      });
    },

    getStockBalanceLogList(keyWord) {
      return new Promise((resolve, reject) => {
        GetStockBalanceLog({
          keyWord: keyWord,
          pageIndex: 1,
          pageSize: 100,
          loginWarehouseId: this.mySessionStorage.getWarehouseId(),
          loginDeptId: this.mySessionStorage.getDeptId(),
        }).then((response) => {
          if (response && response.returnData) {
            this.stockBalanceLogList = response.returnData.data;
            this.stockBalanceLogList.map((item) => {
              item.name = `${item.warehouseName} ${this.parseTime(
                new Date(item.startDate),
                "{y}-{m}-{d}"
              )}至${this.parseTime(new Date(item.endDate), "{y}-{m}-{d}")}`;
              return item;
            });
            resolve(this.stockBalanceLogList);
          } else {
            reject(response);
          }
        });
      });
    },
    resize(e){
      
      console.log(e);
      
    }
  },
  created() {
    this.query.viewMode = 0;
  },
  mounted() {
    window.addEventListener("cilck", this.resize);
    this.$refs["selectFilter"].query.viewMode = 0;
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-table__header-wrapper {
  height: 100% !important;
}

// /deep/.el-table--border .el-table__cell {
//   border-right: 0px !important;
// }
/deep/.el-dialog__body {
  overflow: auto !important;
}

// .dj-table .el-table >>> .cell {
//   line-height: 30px !important;
//   text-align: unset;
// }</style>
